import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("img", {
    class: "mr-3 h-6 sm:h-9",
    src: _ctx.image || require('../../assets/images/logo.svg'),
    alt: _ctx.image + '_alt',
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go.redirectToPage('home')))
  }, null, 8, _hoisted_1))
}